import { format } from 'date-fns'
import { listVndlyTimesheetIssues } from 'api/vndly/listTimesheetIssues'
import { QueryKeys } from 'queries/types'

type VndlyTimesheetIssuesKeyParams = Parameters<
  typeof listVndlyTimesheetIssues
>[0]

const ROOT = 'vndly' as const

export const vndlyKeys = {
  all: [ROOT],
  timesheetIssues: (params?: VndlyTimesheetIssuesKeyParams) => [
    ROOT,
    'timesheetIssues',
    params?.companyIds.join(','),
    params?.startDate ? format(params.startDate, 'yyyy-MM-dd') : undefined,
    params?.endDate ? format(params.endDate, 'yyyy-MM-dd') : undefined,
  ],
} satisfies QueryKeys
